var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEffortIconBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke secondary-fill",
    d: "M10 2.15a4 4 0 0 1 4 0l5.53 3.2a4 4 0 0 1 2 3.46v6.38a4 4 0 0 1-2 3.46L14 21.85a4 4 0 0 1-4 0l-5.53-3.2a4 4 0 0 1-2-3.46V8.81a4 4 0 0 1 2-3.46L10 2.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "task inner",
    d: "m7.1 15.22.03-.04m1.65 1.73.04-.04m0 0-.34.33c-.2.19-.52.19-.72-.01l-.95-.95a.51.51 0 0 1 0-.72l.32-.34m1.69 1.69 3-2.97-1.69-1.68-3 2.96m1.69 1.69.05-.05c.2-.19.56-.26.82-.15l.64.26c.26.1.47.42.48.7v.54c.01.27.24.5.52.5h1.34c.28 0 .5-.23.51-.5l.01-.55c.01-.27.22-.58.48-.69l.64-.26c.25-.1.62-.04.82.15l.4.38c.2.19.51.18.71-.01l.95-.95c.2-.2.2-.52 0-.72l-.37-.39a.83.83 0 0 1-.15-.82l.26-.64c.1-.26.42-.47.7-.48h.54c.27-.01.5-.24.5-.52v-1.34c0-.28-.23-.5-.5-.51l-.55-.01a.83.83 0 0 1-.69-.48l-.26-.64a.83.83 0 0 1 .15-.82l.38-.4c.19-.2.18-.51-.01-.71l-.95-.95a.51.51 0 0 0-.72 0l-.39.37c-.2.19-.56.26-.82.15l-.64-.26a.83.83 0 0 1-.48-.7v-.54c-.01-.27-.24-.5-.52-.5h-1.34c-.28 0-.5.23-.51.5l-.01.55c-.01.27-.22.58-.48.69l-.64.26a.83.83 0 0 1-.82-.15l-.4-.38a.51.51 0 0 0-.7.01l-.96.95c-.2.2-.2.52 0 .72l.37.39c.19.2.26.56.15.82l-.26.64a.83.83 0 0 1-.7.48h-.54c-.27.01-.5.24-.5.52v1.34c0 .28.23.5.5.51l.55.01c.27.01.58.22.69.48l.26.64c.1.25.04.62-.15.82l-.05.05",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "task inner",
    d: "m13.42 14.5 1.2-1.2a.7.7 0 0 0-.01-.98l-2.93-2.93a.7.7 0 0 0-1 0L9.5 10.6a.7.7 0 0 0 0 .99l2.92 2.93a.7.7 0 0 0 1 0Z",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "doc inner",
    d: "M9.67 9.33h4.66M9.67 12h4.66m-4.66 2.67H13m-5.67.66V8.67c0-1.26 0-1.89.4-2.28C8.1 6 8.73 6 10 6h4c1.26 0 1.89 0 2.28.4.39.38.39 1.01.39 2.27v6.66c0 1.26 0 1.89-.4 2.28-.38.39-1.01.39-2.27.39h-4c-1.26 0-1.89 0-2.28-.39-.39-.4-.39-1.02-.39-2.28Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffortIconBanner);
export default __webpack_public_path__ + "static/media/effort_icon_banner.3b6a3b5d5197852f32431b7005f1dcfc.svg";
export { ForwardRef as ReactComponent };